export default __webpack_public_path__ + "static/media/207.1d8822ce.jpg";